export const handleSortUtm = (key, count, setCount, setUtmCopyData, setOpa,utmData) => {
    if (count === 0) {
      setOpa("dsc");
      setCount(1);
      let filterToday = utmData?.today?.sort(
        (a, b) => Number(a[key]) - Number(b[key])
      )
      let filterYesterday = utmData?.yesterday?.sort(
        (a, b) => Number(a[key]) - Number(b[key])
      )
      setUtmCopyData({
        today: [...filterToday],
        yesterday: [...filterYesterday],
      });
    } else if (count === 1) {
      setOpa("asc");
      setCount(2);
      let filterToday = utmData?.today?.sort(
        (a, b) => Number(b[key]) - Number(a[key])
      )
      setUtmCopyData({
        today: [...filterToday],
        yesterday: utmData?.yesterday,
      });
    } else if (count === 2) {
      setOpa("");
      setCount(0);
      setUtmCopyData(utmData);
    }
  };


  export const calculatePercentage = (todayResponse, yesterdayResponse) => {
    const todayResponseSum = Number(todayResponse).toFixed(2);
    const yesterdayResponseSum = Number(yesterdayResponse).toFixed(2);

    let returnSum = 0;
    if (todayResponseSum > yesterdayResponseSum) {
      returnSum =
        ((todayResponseSum - yesterdayResponseSum) / yesterdayResponseSum) *
        100;
    } else if (todayResponseSum < yesterdayResponseSum) {
      returnSum =
        ((yesterdayResponseSum - todayResponseSum) / yesterdayResponseSum) *
        100;
    } else {
      returnSum = 0;
    }
    return returnSum.toFixed(2);
  };


  
